import cns from "classnames";

import iconBankCard from "./images/bank-card";
import iconCard from "./images/card";
import iconDevice from "./images/device";
import iconDolyami from "./images/dolyami";
import iconHanger from "./images/hanger";
import iconHangerBroken from "./images/hanger-broken";
import iconStore from "./images/store";
import iconTruck from "./images/truck";
import styles from "./index.module.scss";

type Card = {
    icon:
        | "bankCard"
        | "card"
        | "device"
        | "dolyami"
        | "hangerBroken"
        | "hanger"
        | "store"
        | "truck"
        | null;
    text: string;
};

export type CardsProps = {
    className?: string;
    cards: Card[];
};

const icons = {
    bankCard: iconBankCard(),
    card: iconCard(),
    device: iconDevice(),
    dolyami: iconDolyami(),
    hangerBroken: iconHangerBroken(),
    hanger: iconHanger(),
    store: iconStore(),
    truck: iconTruck(),
};

const Cards: React.FC<CardsProps> = ({ className, cards }) => {
    if (!cards?.length) {
        return null;
    }

    return (
        <div className={cns(className, styles.component, "text text_h5")}>
            {cards.map((card, cardIndex) => (
                <div key={cardIndex} className={styles.component__card}>
                    {card.icon && (
                        <div
                            className={styles.component__icon}
                            dangerouslySetInnerHTML={{
                                __html: icons[card.icon],
                            }}
                        ></div>
                    )}

                    <div className={styles.component__text}>{card.text}</div>
                </div>
            ))}
        </div>
    );
};

export default Cards;
